// 0058: to-do's op het bord (oprichter 1 okt: "lange termijn taken die niet tijd en datum gebonden
// zijn"). Onder de taken van een lid: de eerste drie rustig in lichtgrijs, een pijl naar beneden
// en een blad met de hele lijst. Kort, je-vorm.
export const todoNl = {
    /** Kopje boven het blokje en het blad. */
    title: 'To-do',
    /** Wie hem maakte, klein onder de titel. */
    from: 'van {name}',
    /** Pijl naar beneden: de hele lijst openen. */
    all: "Alle to-do's ({count})",
    /** Titel van het blad. */
    sheetTitle: "To-do's van {name}",
    /** "Uiterlijk" zonder tijd. */
    due: 'uiterlijk {date}',
    /** Lege lijst in het blad. */
    empty: 'Niets meer te doen',
    /** Afgevinkt (blijft een dag staan). */
    done: 'Klaar',
    /** Widget To-do's: de knop voor iedereen (naast de gezinsleden). */
    everyone: 'Alle',
    /** Widget To-do's (rijk): filters, Afgerond, details, toevoegen, belangrijk. */
    filterOpen: 'Open',
    filterDone: 'Afgerond',
    filterAll: 'Alles',
    doneSection: 'Afgerond ({n})',
    doneBy: '{name} · {when}',
    forWho: 'voor {name}',
    created: 'gemaakt op {date}',
    important: 'Belangrijk',
    add: 'To-do toevoegen',
    noDescription: 'Geen uitleg',
    emptyDone: 'Deze week nog niets afgerond',
    /** To-do toewijzen (oprichter 2 okt). */
    assign: 'Toewijzen aan…',
    assignTitle: 'Toewijzen aan',
    assignSave: 'Toewijzen',
    assigned: 'Toegewezen',
    assignFailed: 'Toewijzen lukte niet',
};
//# sourceMappingURL=todo.nl.js.map